import alpine from "./modules/alpine";
import swiper from "./modules/swiper";

window.addEventListener("DOMContentLoaded", () => {
    alpine();
    swiper();

});